import { S4yModal } from '../modals/s4yModal';
import { UserLoginSplashScreenOptions } from './userLoginSplashScreenOptions';
import { el, text } from "redom";
import { LogHelpers } from '../logHelper';
import { UserLoginSplashScreenData } from './userLoginSplashScreenData';
import { truncate } from '../truncate';
import { Notification } from './userLoginSplashScreenData';
import { disableWait, showWait } from '../globalHelpers';

/**
 * UserLoginSplashScreen entry
 */
export class UserLoginSplashScreen {

    // flag indicate the contact form is open or not?
    private static contactAdminFormIsOpen = false;
    // options from caller
    private static options: UserLoginSplashScreenOptions;
    private static data: UserLoginSplashScreenData;

    // toggle contactAdminModalBodyElement open/close
    private static toggleContactAdminFormElement: HTMLAnchorElement;
    private static toggleContactAdminFormIconElement: HTMLElement;

    // modal body that contain contact form
    private static contactAdminModalBodyElement: HTMLDivElement;
    private static contactAdminFormElement: HTMLFormElement;
    // textarea reference here to set focus
    private static contactAdminTextAreaElement: HTMLTextAreaElement;

    // Modal wrapper object. don't change the paramenter for user login splash screen here.
    // The pamameter is used to in css selector to style the modal
    private static modal = new S4yModal('UserLoginSplashScreen-modal');
    private static logHelper = new LogHelpers('UserLoginSplashScreen');

    /**
     * Build modal-header div element, append it to modal
     */
    private static buildModalHeader() {
        const header = this.modal.getModalHeader();
        header.modalTitleElement.appendChild(el('h3', [this.options.i18n.modalTitle]));
        header.closeButtonElement.addEventListener('click', () => {
            this.modal.closeModal();
        });
        this.modal.append(header.modalHeaderElement);
    }

    /**
     * Build modal-body element that contain the main content (welcome and messages from admin)
     * */
    private static buildWelcomeAndMessagesModalBody() {
        const welcomeAndMessagesModalBodyElement = this.modal.getModalBody();
        welcomeAndMessagesModalBodyElement.classList.add('welcome-and-messages');
        if (this.options.logoUrl && this.options.logoUrl.trim().length) {
            const logo = el('div', { class: 'logo' }, [el('img', { src: `${this.options.logoUrl}` })]);
            welcomeAndMessagesModalBodyElement.appendChild(logo);
        }

        const welcome = this.options.i18n.welcomeMessage.split('{?}');
        welcomeAndMessagesModalBodyElement.appendChild(el('div', [`${welcome[0]}`, el('a', { href: `${this.options.userProfileUrl}`, target: '_blank' }, `${this.data.userName}`), `${welcome[1]}`]));
        welcomeAndMessagesModalBodyElement.appendChild(el('br'));
        welcomeAndMessagesModalBodyElement.appendChild(el('div', `${this.options.i18n.projectLabel}: ${this.data.mainProjectTitle}`));
        welcomeAndMessagesModalBodyElement.appendChild(el('div', `${this.options.i18n.lastLoginLabel}: ${this.data.userLastLogin}`));
        
        const notificationReadAllContainerElement = el('div', { class: 'notifications-read-all' });
        if (this.data.notifications && this.data.notifications.length) {
            welcomeAndMessagesModalBodyElement.appendChild(el('br'));
            welcomeAndMessagesModalBodyElement.appendChild(el('div', `${this.options.i18n.notificationsLabel}:`));
            // Build notification list
            this.data.notifications.forEach(n => {
                const notificationListItem = this.buildNotificationListItemElement(n);
                welcomeAndMessagesModalBodyElement.appendChild(notificationListItem);
            });
            // notificationReadAllContainerElement.appendChild(el('a', { href: '#' }, 'Read all Notifications'));
            // notificationReadAllContainerElement.appendChild(text(' '));
        }

        this.toggleContactAdminFormElement = el('a', {
            // class: 'contact-form-toggle',
            href: 'javascript:void(0);',
            title: !this.contactAdminFormIsOpen ? 'Open the contact form' : 'Collapse the contact form'
        }, [
            this.toggleContactAdminFormIconElement = el('i', { class: `fas fa-${this.contactAdminFormIsOpen ? 'angle-up' : 'angle-down'}` }),
            text(' '),
            this.options.i18n.contactFormToggle
        ]);

        // Catch event to close/open the contact form
        this.toggleContactAdminFormElement.addEventListener('click', () => {
            if (this.contactAdminFormIsOpen === true) {
                // collapse the contactAdminModalBody
                this.contactAdminModalBodyElement.style.display = 'none';
                // update arrow icon
                this.toggleContactAdminFormIconElement.classList.remove('fa-angle-up');
                this.toggleContactAdminFormIconElement.classList.add('fa-angle-down');
                this.toggleContactAdminFormElement.title = 'Open the contact form';
            } else {
                // open the form
                this.contactAdminModalBodyElement.style.display = 'block';
                this.contactAdminTextAreaElement.focus();
                this.toggleContactAdminFormIconElement.classList.remove('fa-angle-down');
                this.toggleContactAdminFormIconElement.classList.add('fa-angle-up');
                this.toggleContactAdminFormElement.title = 'Collapse the contact form';
            }
            this.contactAdminFormIsOpen = !this.contactAdminFormIsOpen;
        });

        notificationReadAllContainerElement.appendChild(el('div', this.toggleContactAdminFormElement));
        notificationReadAllContainerElement.appendChild(el('br'));
        notificationReadAllContainerElement.appendChild(el('div', el('a', {href: `${this.options.userProfileUrl}`, target: '_blank'}, this.options.i18n.dontAskMeLaterLabel)));
        welcomeAndMessagesModalBodyElement.appendChild(notificationReadAllContainerElement);

        this.modal.append(welcomeAndMessagesModalBodyElement);
    }

    private static buildContactAdminModalBody() {
        // 1. build contact form
        this.contactAdminTextAreaElement = el('textarea', {
            class: 'd-form-control',
            placeholder: this.options.i18n.contactForm.textAreaPlaceHolder, //'Share your thinking ...',
            rows: 5,
            autofocus: true
        });
        const sendContactFormButtonElement = el('button', { class: 'd-btn d-btn-primary btn-send', type: 'button' }, this.options.i18n.contactForm.sendButton);
        sendContactFormButtonElement.addEventListener('click', () => {
            this.logHelper.log(`Send contact from content=${this.contactAdminTextAreaElement.value}, url=${this.options.contactFormPostUrl}`);
            const formData = new FormData();
            formData.append("comment", this.contactAdminTextAreaElement.value);
            formData.append("url", location.href);
            formData.append("id", 'SplashScreen_1');
            formData.append("reason", '3');
            formData.append('source', 'splash');
            showWait();
            fetch(this.options.contactFormPostUrl, {
                credentials: 'include',
                method: "post",
                body: formData,
            }).then(rep => {
                disableWait();
                // Reset contact form and collapse the form
                this.contactAdminFormElement.reset();
                this.toggleContactAdminFormElement.click();
                alert(this.options.i18n.contactForm.sendMessageSuccessfully);
            });
        });

        this.contactAdminFormElement = el('form', [
            el('div', { class: 'd-form-group form-group-to' }, [
                el('label', { for: 'to', class: 'd-col-form-label' }, this.options.i18n.contactForm.toLabel),
                el('div', { class: '' }, [
                    el('input', {
                        type: 'text',
                        class: 'd-form-control',
                        id: 'to',
                        disabled: true,
                        value: `${this.data.mainProjectTitle} administrator`
                    })
                ])
            ]),
            el('div', { class: 'd-form-group' }, [
                this.contactAdminTextAreaElement
            ]),
            el('div', { class: 'd-form-group' }, [
                sendContactFormButtonElement
            ])
        ]);
        const contactAdminForm = el('div', [
            el('h3', this.options.i18n.contactForm.title),
            this.contactAdminFormElement
        ]);

        this.contactAdminModalBodyElement = this.modal.getModalBody();
        this.contactAdminModalBodyElement.classList.add('contact-admin-form');
        this.contactAdminModalBodyElement.style.display = this.contactAdminFormIsOpen ? 'block' : 'none';
        this.contactAdminModalBodyElement.appendChild(contactAdminForm);
        this.modal.append(this.contactAdminModalBodyElement);
    }

    /**
     * Build modal-footer that contain the main footer buttons
     * */
    private static buildWelcomeAndMessagesModalFooter() {
        // Look good button
        const lookGoodButtonElement = el('button', { class: 'd-btn d-btn-primary' }, [this.options.i18n.lookGoodButton]);
        lookGoodButtonElement.addEventListener('click', () => {
            this.modal.closeModal();
        });

        const welcomeAndMessagesFooterContent = this.modal.getModalFooter();
        welcomeAndMessagesFooterContent.classList.add('d-modal-footer-block');
        welcomeAndMessagesFooterContent.appendChild(lookGoodButtonElement);
        this.modal.append(welcomeAndMessagesFooterContent);
    }

    private static buildNotificationListItemElement(n: Notification): HTMLDivElement {
        const notificationTitleElement = el('div', { class: 'notification-title' }, [
            el('small', n.TITLE),
            el('small', { class: 'notification-confirm-status' }, [
                el('i', this.options.i18n.confirmedNotificationDecorationLabel)
            ])
        ]);
        if (!n.CONTENT) {
            n.CONTENT = '';
        }
        const truncatedContent = truncate(n.CONTENT, 100, {});
        const showCollapseLink = truncatedContent.length !== n.CONTENT.length;
        const notificationMainContent = el('div', { class: 'notification-content' });
        notificationMainContent.innerHTML = truncatedContent;
        const notificationActions = el('div', { class: 'notification-actions' });
        const notificationListItem = el('div', { class: n.ISCONFIRMED === 1 ? 'notification-confirmed notification-list-item' : 'notification-list-item' }, [
            notificationTitleElement,
            notificationMainContent,
            notificationActions
        ]);
        let isShowMore = false;
        if (showCollapseLink) {
            const toggleLinkElement = el('a', { href: 'javascript:void(0);' }, el('i', !isShowMore ? this.options.i18n.notificationShowMore : this.options.i18n.notificationShowLess));
            toggleLinkElement.addEventListener('click', () => {
                isShowMore = !isShowMore;
                toggleLinkElement.querySelector('i').innerText = !isShowMore ? this.options.i18n.notificationShowMore : this.options.i18n.notificationShowLess;
                notificationMainContent.innerHTML = isShowMore ? n.CONTENT : truncatedContent;
            });
            notificationActions.appendChild(toggleLinkElement);
        }
        if (n.CONFIRMNEEDED === 1) {
            const confirmButtonElement = el('button', { type: 'button', class: 'd-btn d-btn-primary btn-confirm-notification' }, this.options.i18n.confirmNotificationButton);
            confirmButtonElement.addEventListener('click', () => {
                const url = `${this.options.confirmNotificationUrl}&nId=${n.NOTIFICATIONID}&field=CONFIRMED`;
                showWait();
                fetch(url).then(() => {
                    // Apply new style to the notification
                    notificationListItem.classList.add('notification-confirmed');
                    disableWait();
                });
            });
            notificationActions.appendChild(confirmButtonElement);
        }

        return notificationListItem;

    }

    static run(options: UserLoginSplashScreenOptions): Promise<any> {
        this.options = options;
        const closeSplashScreenPromise = new Promise<any>((resolve, reject) => {
            showWait();
            fetch(this.options.userLoginSplashScreenDataUrl).then(rep => rep.json())
                .then(data => {
                    disableWait();
                    this.data = data;
                    // Check data decide to show the screen or not
                    if ((!this.data.notifications || !this.data.notifications.length) && this.data.noSplash === true) {
                        resolve(undefined);
                    } else {
                        this.logHelper.log(this.options);
                        this.logHelper.log(this.data);
                        this.buildModalHeader();
                        this.buildWelcomeAndMessagesModalBody();
                        this.buildWelcomeAndMessagesModalFooter();
                        this.buildContactAdminModalBody();

                        this.modal.$modalClosed = () => {
                            // Call to API to set setPresented on all notifications
                            showWait();
                            const promiese = this.data.notifications.map(n => n.NOTIFICATIONID).map(id => {
                                const url = `${this.options.confirmNotificationUrl}&nId=${id}&field=PRESENTED`;
                                this.logHelper.log(`set PRESENTED to notification, id=${id}`);
                                return fetch(url);
                            });
                            Promise.all(promiese).then(() => {
                                disableWait();
                                resolve(undefined);
                            });
                        };
                        this.modal.openModal();
                    }
                });
        });

        return closeSplashScreenPromise;
    }
}